import type { ReactNode } from "react";

/** 页面里的白底卡片。管理端每一块内容都套它，间距统一在这里改 */
export function Panel({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <section className={`rounded-base border border-line-lighter bg-white p-4 ${className}`}>{children}</section>;
}

/**
 * 面板标题。`actions` 紧贴标题（属于这块内容的操作），`extra` 推到最右
 * （标签、计数这类说明）——两者混在一侧时，按钮会被标签挤得找不到。
 */
export function SectionTitle({ children, extra, actions }: { children: ReactNode; extra?: ReactNode; actions?: ReactNode }) {
  return (
    <div className="mb-3 flex flex-wrap items-center gap-3">
      <h2 className="text-base font-semibold text-ink">{children}</h2>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
      {extra && <div className="ml-auto flex items-center gap-2">{extra}</div>}
    </div>
  );
}

/**
 * 查询/工具条。设计稿里 8 个页面各写了一遍 className="search"，
 * 统一成组件：左边放筛选项，右边放动作按钮。
 */
export function Toolbar({ left, right }: { left?: ReactNode; right?: ReactNode }) {
  return (
    <div className="mb-page flex flex-wrap items-center gap-2.5 rounded-base border border-line-lighter bg-white px-3 py-2">
      <div className="flex flex-wrap items-center gap-2.5">{left}</div>
      {right && <div className="ml-auto flex items-center gap-2.5">{right}</div>}
    </div>
  );
}

export function Segmented<T extends string>({
  value, options, onChange, disabled,
}: { value: T; options: { value: T; label: ReactNode }[]; onChange: (v: T) => void; disabled?: boolean }) {
  return (
    <div className="inline-flex rounded-base border border-line p-0.5">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          disabled={disabled}
          onClick={() => onChange(o.value)}
          className={
            "h-[26px] rounded-sm px-3 text-sm font-medium transition-colors " +
            (o.value === value ? "bg-primary text-white" : "text-ink-regular hover:text-primary")
          }
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
